<div class="wrap">
  <div class="form-wrap">
    @if (h1Header) {
      <h1>{{ h1Header }}</h1>
    }
    <div class="positioning-container" [class.query-open]="queryAddresses.length">
      <form [formGroup]="queryForm">
        <p>{{ instructionText }}</p>
        <div class="d-flex w-100">
          <div class="input-group w-100">
            <input type="text" class="form-control" placeholder="Mein Standort"
              aria-label="Mein Standort" aria-describedby="basic-addon2"
              formControlName="query" type="text" (keyup)="navigateQueryAddresses($event)"
              >
            <span class="input-group-text" id="basic-addon2"
              (click)="centerQueryAddress()"
              ngbTooltip="Ausgewählten Ort zentrieren" placement="auto" container="div.positioning-container">
              <svg viewBox="15 15 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 20L23 20" stroke="#F9F2EC" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M21 17L23.9167 19.9167L21 22.8333" stroke="#F9F2EC" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>

            @if (queryAddresses.length) {
              <div class="query-dropdown">
                <ul>
                  @for (address of queryAddresses; track address; let i = $index) {
                    <li (mouseover)="selectedQueryAddressesIndex = i"
                      (click)="selectQueryAddress(address)">
                      <span [ngClass]="{'selected': selectedQueryAddressesIndex === i}">
                        {{ address.display_name }}
                      </span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
          <div class="flex-shrink-1">
            <button type="button" class="btn btn-form-icon locate"
              ngbTooltip="Aktuelle Position ermitteln" placement="auto" container="div.positioning-container"
              (click)="setCurrentPosition()"
              >
              <svg [class.loading]="locatorLoading" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6C12 10.6667 6 14.6667 6 14.6667C6 14.6667 0 10.6667 0 6C2.37122e-08 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6Z" fill="#fff" />
                <circle cx="6" cy="6" r="2.4" fill="black" />
              </svg>
            </button>
          </div>
        </div>
      </form>

      <div class="store-list" #locationList>
        <ul>
          @for (location of locations(); track location) {
            @if (location.filtered === undefined || location.filtered === false) {
              <li
                class="location-{{ location.idPerson }}"
                [class.selected]="selectedLocation && selectedLocation.idPerson == location.idPerson"
                [class.disabled]="this.distinctProduct && ! isStorePickupPossible(location)"
                >
                <div class="p-3 mt-2 d-flex w-100" (click)="onSelectLocation(location)">
                  <div class="pe-3 radio-column">
                    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" class="radio">
                      <circle cx="16" cy="16" r="10" class="inner"></circle>
                      <circle cx="16" cy="16" r="14" class="outer"></circle>
                    </svg>
                  </div>
                  <div class="flex-grow-1">
                    @if (! distinctProduct) {
                      <svg class="location-toggler"
                        [class.expanded]="selectedLocation == location" viewBox="0 0 32 17"
                        >
                        <line x1=2 y1=2 x2=16.7 y2=16.7 stroke="black" stroke-width="2" />
                        <line x1=16 y1=16 x2=30 y2=2 stroke="black" stroke-width="2" />
                      </svg>
                    }
                    <strong>
                      {{ location.name }}
                      @if (distinctProduct) {
                        <br>
                          @if (! location.storePickupPossible) {
                            <span class="txt-grey">Derzeit keine Online-Reservierung möglich!</span>
                          } @else {
                            @if (location.stock < quantity) {
                              @if (isStorePickupPossible(location)) {
                                <span [class]="inStockClass() + ' deliverytime'">{{ inStockMessage() }}</span>
                              } @else {
                                <span class="txt-red">nicht verfügbar</span>
                              }
                            }
                          }
                          @if (location.stock >= quantity) {
                            <span class="txt-green">verfügbar</span>
                          }
                        }
                      </strong><br />

                      @if (location.phone) {
                        <span class="telephone">Telefon: <a [attr.aria-label]="" [phoneLink]="location.phone"></a><br /></span>
                      }
                      <span>{{ location.address.street }} / {{ location.address.postalcode }} {{ location.address.city }}</span>
                      <div class="oh-wrap" [class.hidden]="! (selectedLocation?.idPerson == location.idPerson && ! this.distinctProduct)">
                        <gea-shop-opening-hours [location]="selectedLocation" [now]="currentDate" />
                        <button type="button" class="btn btn-green btn-sm d-block mt-3"
                          (click)="openLocationDetail(location)"
                        >Details zur Filiale</button>
                      </div>
                    </div>
                  </div>
                </li>
              }
            }
          </ul>
        </div>
      </div>
    </div>
    <div class="map-wrap">
      @if (showMap) {
        <gea-shop-osm-component #mapComponent
          [options]="{ center: [ 50.3734961443035, 11.513671875000002 ], zoom: 5 }"
          (coordinatesChange)="onCoordinatesChange($event)"
          [locations]="locations()"
          [distinctProduct]="distinctProduct"
          [quantity]="quantity"
          [customerLocation]="customerLocation"
          (markerClick)="toggleLocationDetails($event)"
        ></gea-shop-osm-component>
      }
    </div>
  </div>